/* sz-customall-variant-fix.js — AI Agent làm theo chỉ thị của anh Hoá — 2026-10-16 02:55 VN — WEB-20261016-suzitee-customall-style-variant
   Đã làm: SP Customall nhiều option (vd Style Poster/Canvas + Size) — đổi Style thì danh sách Size đổi nhưng
   variant/giá/variant-id(input name=id)/URL/ảnh vẫn GIỮ NGUYÊN cho tới khi bấm 1 Size, vì value Size cũ không
   hợp lệ cho Style mới (poster "36″ x 24″" vs canvas "36″x24″") → không khớp variant nào → theme giữ variant cũ.
   NAY: sau mỗi lần đổi 1 swatch, nếu cặp option đang chọn KHÔNG ra variant hợp lệ thì tự chọn variant available
   đầu tiên khớp đúng option vừa đổi, set lại các option/swatch/select còn lại rồi bắn 'change' để theme (Shopify
   OptionSelectors) cập nhật ngay variant id + giá + URL + ảnh. Chỉ can thiệp khi cặp KHÔNG hợp lệ nên SP 1-option
   hay SP cặp luôn hợp lệ (crossword…) không bị đụng. Dùng product JSON của chính form, không gọi/đổi app.
   An toàn: chạy trong rAF sau handler theme; chỉ nghe radio trong .swatch; set .checked + trigger change trên
   <select> (không bắn change radio) nên không tự kích lại, không vòng lặp. */
(function () {
  'use strict';
  if (window.__szCAVariantFix) return; window.__szCAVariantFix = 1;
  function norm(s) { return s == null ? '' : String(s); }
  function esc(v) { try { return (window.CSS && CSS.escape) ? CSS.escape(v) : v.replace(/(["\\])/g, '\\$1'); } catch (e) { return v; } }
  function reconcile(radio) {
    try {
      var $ = window.jQuery; if (!$) return;
      var form = radio.closest('form[action="/cart/add"]'); if (!form) return;
      var pf = radio.closest('.product_form'); if (!pf) return;
      var data = $(pf).data('product');
      if (!data || !data.variants || !data.options || data.options.length < 2) return; // chỉ SP >=2 option
      var swatches = form.querySelectorAll('.swatch_options .swatch[data-option-index]');
      var chosen = [];
      swatches.forEach(function (sw) {
        var idx = parseInt(sw.getAttribute('data-option-index'), 10);
        var r = sw.querySelector('input:checked');
        chosen[idx] = r ? r.value : null;
      });
      function match(v) { for (var i = 0; i < data.options.length; i++) { if (norm(v.options[i]) !== norm(chosen[i])) return false; } return true; }
      var valid = data.variants.filter(function (v) { return v.available && match(v); })[0]
               || data.variants.filter(function (v) { return match(v); })[0];
      if (valid) return; // cặp hợp lệ → theme đã xử lý đúng, không đụng
      // cặp KHÔNG hợp lệ → tìm variant available đầu tiên khớp option vừa đổi
      var sw0 = radio.closest('.swatch'); if (!sw0) return;
      var ci = parseInt(sw0.getAttribute('data-option-index'), 10);
      var cv = radio.value;
      var cand = data.variants.filter(function (v) { return v.available && norm(v.options[ci]) === norm(cv); })[0]
              || data.variants.filter(function (v) { return norm(v.options[ci]) === norm(cv); })[0];
      if (!cand) return;
      var genSel = form.querySelectorAll('.single-option-selector');
      for (var i = 0; i < data.options.length; i++) {
        var val = cand.options[i];
        var swi = form.querySelector('.swatch[data-option-index="' + i + '"]');
        if (swi) { var ri = swi.querySelector('input[value="' + esc(val) + '"]'); if (ri && !ri.checked) ri.checked = true; }
        if (genSel[i]) $(genSel[i]).val(val);
      }
      // bắn change để Shopify.OptionSelectors tính lại cặp hợp lệ → cập nhật variant id/giá/URL/ảnh
      var other = ci === 0 ? 1 : 0;
      if (genSel[other]) $(genSel[other]).trigger('change');
      if (genSel[ci]) $(genSel[ci]).trigger('change');
    } catch (e) { }
  }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.type !== 'radio' || !t.closest || !t.closest('.swatch_options .swatch')) return;
    requestAnimationFrame(function () { reconcile(t); }); // chạy sau handler theme của cùng event
  }, false);
})();
